
<a href="javascript:void(0)" (click)="signout()" class="logout"> Logout </a>
<button id='logoutpop' style='display: none' type="button" class="btn btn-info btn-lg" data-bs-toggle="modal" data-bs-target="#logoutModal" aria-hidden="true">Open Modal</button>

<!-- Modal -->

<div id="logoutModal" class="modal" role="dialog" style="text-align:center" aria-hidden="true">
  <div class="modal-dialog ">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
        <h3 class="modal-title">Logout</h3>
      </div>
      <div class="modal-body">
        <p>Do you want to save your data before logging out?</p>
        <p></p>
        <p></p>
        <p>
          <button (click)='saveYes()' class='dont_save' >Yes</button>
          <button  (click)='saveNo()' class='dont_save' >No</button>
          <button  data-bs-dismiss="modal" class='dont_save' >Cancel</button>
        </p>
      </div>
      <div class="modal-footer">
      </div>
    </div>

  </div>
</div>
<!-- end Modal -->
